import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux';
import $ from 'jquery'
import {
    setRegPage, setLoadingMass,
    validateGuestdetail, popupOpenClose,
    setDeviceLoginPage, currentWidget, validateReservationNo,
    setDoorKeyValidationPopUp, SetCallNativeMethods,
    setDoorKeyNotificaionPage, setQRScannerPage, setErrorPopDoorKey,
    setToRescan, setLocationId
} from '../../action/action'
import { guestDdeviceRegColorset } from '../../JS/setColors'
import { defultIP, globalSalt, globalIV, doNotDisturbCall } from '../../config/constant'
import { setWebViewAfterKeyBoard } from '../../JS/setWebView'
import { wipeGuestData } from '../../JS/wipeGuestData'
import { AesUtil } from '../../JS/AesUtil';
import CryptoJS from 'crypto-js'
import ErrorPop from './errorPop'
import { fetchSessionToken } from '../../JS/fetchSessionToken'
import { QRSCANENABLE } from '../../config/constant'
import { HashRouter, Redirect } from 'react-router-dom';
import { setShowRoomDoor } from '../../layout2.0/action/homeAction'
import { getDefaultAnalyticsLabel } from '../../layout2.0/JS/utility';
import { sendAnalytics } from '../../action/homeAction';

class LoginPopUp extends Component {
    constructor(props) {
        super(props);
        this.nameInput = 0
        this.state = {
            roomNo: "",
            GuestName: null,
            status: false,
            error: false,
            errorMsg: null,
            deviceError: false,
            deviceErrorMsg: null,
            reservNo: "",
            showOnlyReservation: false,
            locationId: this.props.guestDetail.locationId,
            submitClick: true,
            showRoomDoorPage:false
        }
    }

    handleSubmit = (event) => {
        console.log("on submit", event);
        //alert("on submit");
        let encodData = fetchSessionToken();
        let srcElement;
        event.preventDefault();
        if (this.state.error) {
            this.setState({ error: false });
        }
        event.srcElement ? srcElement = event.srcElement
            : srcElement = { deviceName: {}, IPAddress: {} }
        let guestName = //event.target.guestName.value || srcElement.guestName.value || 
            document.getElementById("InputForguestName2").value;
        let roomNumber = //event.target.roomNo.value || srcElement.roomNo.value || 
            document.getElementById("InputForroomNo2").value;
        if (guestName && roomNumber) {
            this.props.validateGuestdetail(encodData, guestName, roomNumber, this.callBackFunc);
            this.props.setLoadingMass(true);

        } else {
            console.log("complete session flow first");
            this.props.popupOpenClose(true, "Oops Something went wrong, Please try after some time.");
        }
        // console.log("on submit", event);
        // //alert("on submit");

        // let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        // let srcElement, guestName, roomNumber;
        // event.preventDefault();
        // if (this.state.error) {
        //     this.setState({ error: false });
        // }
        // event.srcElement ? srcElement = event.srcElement
        //     : srcElement = { deviceName: {}, IPAddress: {} }
        // if (!this.state.showOnlyReservation) {
        //     guestName = //event.target.guestName.value || srcElement.guestName.value || 
        //         document.getElementById("InputForguestName").value;
        //     roomNumber = //event.target.roomNo.value || srcElement.roomNo.value || 
        //         document.getElementById("InputForroomNo").value;
        // }
        // // let reservNo = //event.target.roomNo.value || srcElement.roomNo.value || 
        // //     document.getElementById("reservationNo").value;
        // if (!this.state.showOnlyReservation) {
        //     if (SessionToken && guestName && roomNumber) {
        //         this.props.validateGuestdetail(guestName, roomNumber, this.callBackFunc, SessionToken);
        //         this.props.setLoadingMass(true);
        //     } else {
        //         console.log("complete session flow first");
        //         this.props.popupOpenClose(true, "Oops Something went wrong, Please try after some time.");
        //     }
        // } else {
        //     // if (reservNo) {
        //     //     console.log("reservNo", reservNo);
        //     //     this.props.validateReservationNo(SessionToken, reservNo, this.props.guestDetail.locationId, this.reservCallBack);
        //     // } else {
        //     //     console.log("complete reservation No session flow first");
        //     // }
        // }
    }

    checkCameraStatusHandler = () => {
        const platform = window.device.platform;
        
        /*if(platform == "Android") {
            window.cordova.plugins.diagnostic.requestRuntimePermissions(function(statuses){
                for (var permission in statuses){
                    switch(statuses[permission]){
                        case window.cordova.plugins.diagnostic.permissionStatus.GRANTED:
                            console.log("Permission granted to use "+permission);
                            this.props.setQRScannerPage(true);
                            this.startScanner(this.props);
                            break;
                        case window.cordova.plugins.diagnostic.permissionStatus.NOT_REQUESTED:
                            console.log("Permission to use "+permission+" has not been requested yet");
                            this.props.setDoorKeyValidationPopUp(false);
                            break;
                        case window.cordova.plugins.diagnostic.permissionStatus.DENIED_ONCE:
                            console.log("Permission denied to use "+permission+" - ask again?");
                            this.props.setDoorKeyValidationPopUp(false);
                            break;
                        case window.cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
                            console.log("Permission permanently denied to use "+permission+" - guess we won't be using it then!");
                            this.props.setDoorKeyValidationPopUp(false);
                            break;
                    }
                }
            }, function(error){
                console.error("The following error occurred: "+error);
            },[
                window.cordova.plugins.diagnostic.permission.CAMERA
            ]);
        } else {
            this.props.setQRScannerPage(true);
            this.startScanner(this.props);
        }*/
        this.startScanner(this.props);
    }

    startScanner = () => {
        try {
            if (window.QRScanner) {
                
                window.QRScanner.prepare(() => {
                   
                console.log("prepare authorized")
                window.QRScanner.scan(this.displayContents);
                window.QRScanner.show((status) => {
                    console.log("status in show method", status);
                });
                   
                   
                })
               
                // Make the webview transparent so the video preview is visible behind it.
                // Be sure to make any opaque HTML elements transparent here to avoid
                // covering the video.
                //alert("startScanner")
            }
        } catch (err) {
            console.log("error in QRScanner", err)
        }
    }

    displayContents = (err, text) => {
        if (err) {
            // an error occurred, or the scan was canceled (error code `6`)
            //alert("error in scanning->" + err);
            console.log("we got err while scanning", err)
        } else {
            // The scan completed, display the contents of the QR code:
            console.log("we are in scan success");
            window.QRScanner.hide(function (status) {
                console.log(status);
                console.log("scanner hide")
                //alert(status + "-----" + this.props.QRScanPage)
            });
            window.QRScanner.destroy(function (status) {
                console.log("scanner destroy", status);
            });
            this.processScanText(text);
            // reservationNo
        }
    }

    processScanText = (text) => {
        let reservationNo, token, indexDelimiter;
        let reserNo = localStorage.getItem("reservationNo");
        // let iv = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
        // let salt = CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Hex);
        let aesUtil = new AesUtil(128, 1000);
        // let ciphertext = aesUtil.encrypt(
        //     globalSalt,
        //     globalIV,
        //     "1234567891234567",
        //     `${"-1655194519"}&${""}&${""}`
        // );
        // console.log("ciphertext", ciphertext);

        // text = `192.168.43.45:8080/apps/digiKey/index.html?token=${ciphertext}`
        //alert(text);
        // console.log("text", text)
        // console.log("globalSalt, globalIV,", globalSalt, globalIV)
        if (text) {
            indexDelimiter = text.indexOf("token=")
            console.log("indexDelimiter", indexDelimiter)
            token = text.slice(indexDelimiter + 6, text.length);
            //console.log("token", token);
            //alert(token);
            let plaintext = aesUtil.decrypt(
                globalSalt,
                globalIV,
                "1234567891234567",
                token
            )
            //alert(plaintext)
            //console.log("plain text", plaintext)
            if (plaintext) {
                indexDelimiter = plaintext.indexOf("&")
                reservationNo = plaintext.slice(0, indexDelimiter);
                console.log("reservationNo", reservationNo)
                console.log("this.state.locationId : this.props.guestDetail.locationId", this.state.locationId, this.props.guestDetail.locationId)
                if (!reserNo) {
                    this.verifyReservation(
                        reservationNo,
                        this.state.locationId ? this.state.locationId : this.props.guestDetail.locationId
                    );
                }
            } else {
                this.props.setErrorPopDoorKey(true);
                this.props.setQRScannerPage(false);
                //this.props.setDoorKeyNotificaionPage(false);
            }
            //this.props.setDoorKeyValidationPopUp(false);
            this.props.setLoadingMass(false);
        }
    }

    reservCallBack = (status) => {
        console.log("reservCallBack", status);
        this.props.setLoadingMass(false);
        this.props.setRegPage(false);
        //localStorage.setItem("ConnectorIP", defultIP);
        
        if (status) {
            this.props.SetCallNativeMethods(true);
            this.props.setDoorKeyValidationPopUp(false);
            this.props.setQRScannerPage(false);
           
        } else {
            this.props.setErrorPopDoorKey(true);
            this.props.setQRScannerPage(false);
        }
    }

    verifyReservation = (reservNo, locationId) => {
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        // let reservNo = //event.target.roomNo.value || srcElement.roomNo.value || 
        //     document.getElementById("reservationNo").value;
        console.log("verifyReservation reservNo", reservNo, locationId)
        if (reservNo && locationId)
            this.props.validateReservationNo(SessionToken, reservNo, locationId, this.reservCallBack);
        else
            console.log("issue with location or reservation")
    }

    componentDidUpdate(preProp) {
        if (preProp.rescan !== this.props.rescan && this.props.rescan) {
            console.log("rescan");
            this.props.setQRScannerPage(true);
            this.startScanner(this.props);
            this.props.setToRescan(false);
        }
    }

    componentWillUnmount() {
        $("body").css("background", this.props.menuColor.backgroundColor);
    }

    componentDidMount() {
        $("body").css("background", "none");
        let reservationNo = localStorage.getItem("reservationNo");
        let SessionToken = localStorage.getItem("GuestJourneySessionToken");
        let room = localStorage.getItem("room");
        console.log("locationId", this.props.guestDetail.locationId);
        if (SessionToken && (this.props.guestDetail.locationId || this.props.guestDetail.guestToken)) {
            if (!this.props.errorPopUP && !reservationNo || reservationNo === "null") {
                this.setState({ locationId: this.props.guestDetail.locationId })
                this.setState({ showOnlyReservation: true });
                console.log("didmound call");
                this.props.setQRScannerPage(true);
                // this.startScanner(this.props);
                this.checkCameraStatusHandler();
            }
        }
        guestDdeviceRegColorset(this.props.menuColor);
        this.props.currentWidget({});
        //this.processScanText()
        // for iOS on blur event will not fire so to do that we are firing blur event.
        // when we click on any where on body. below function contain that.
        this.setBlurforIos();
    }

    componentWillUnmount() {
        $('body').off("touchstart")
        $('body').off("click")
        $('input').off("click")

    }

    setBlurforIos = () => {
        $('body').on("click", (event) => {
            if (event.target && event.target.id === "InputForguestName2"
                && event.target.id === "InputForroomNo2") {
                console.log("this is click on input");
            } else {
                document.activeElement.blur();
                console.log("blur setBlurforIos");
            }
        });

        $('body').on("touchstart", (event) => {
            console.log("body touch", event.target ? event.target.id : "false");
            //this.handleSubmit(event);
        })

        $('#guestDevRegNext').on("touchstart", (event) => {
            console.log("guestDevRegNext touch");
            if (this.state.submitClick) {
                this.setState({ submitClick: false })
                this.handleSubmit(event);
            }
        })

        $('input').on("click", (event) => {
            event.stopPropagation();
        });
    }

    callBackFunc = (status, room, locationId) => {
        let label = getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""})
        
        if (status) {
            //wipeGuestData({inRoomTab: process.env.REACT_APP_INROOMTAB == "true"});
            localStorage.setItem("room", room);
            console.log("locationId: locationId", locationId)
            this.setState({ locationId: locationId })
            if (!this.props.guestDetail.locationId) {
                this.props.setLocationId(locationId);
            }

            this.props.setQRScannerPage(true);
            this.startScanner(this.props);

            this.props.sendAnalytics(
                this.props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - success",
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget"},
                0,
                (room && room != "null") ? room : false
            );
        } else {
            this.props.sendAnalytics(
                this.props.guestDetail,
                "LINK_TO_ROOM",
                "link to room - failed",
                { ...label, "layoutTab": this.props.currentHomePage.tabName, "element": "widget" },
                0,
                (room && room != "null") ? room : false
            );

            this.props.setLoadingMass(false);
            if (this.props.doorLogin) {
                this.setState({ error: true, errorMsg: "We cannot find that  Name/Room combination, please contact the Front Desk." });
            } else {
                this.props.popupOpenClose(true, "We cannot find that  Name/Room combination, please contact the Front Desk.");
            }
        }
    }

    onNoClick = () => {
        this.props.setRegPage(false);
        if (this.props.guestLoginPage) {
            this.props.setDoorKeyValidationPopUp(false);
            //console.log("location", window.history);
            if (this.props.currentWidget && this.props.currentWidget.widgetType) {
                window.history.back();
            } else {
                document.location.reload();
            }

            //window.location.replace();
        } else {
            document.location.reload();
        }
    }

    handleCHange = (event, field) => {
        let len = event.target.value.length;
        let str = event.target.value.charAt(len - 1);
        let dReg = field === "roomNo" ? new RegExp('^[a-zA-Z0-9 ]+$') : new RegExp('^[a-zA-Z ]+$');
        if (str.match(dReg) || str === "-" || str === "_" || len === 0) {
            if (field === "roomNo") {
                this.setState({ roomNo: event.target.value, error: false });
            } else {
                this.setState({ GuestName: event.target.value, error: false });
            }
        } else {
            if (field === "roomNo") {
                this.setState({
                    roomNo: event.target.value.substring(0, len - 1),
                    error: true, errorMsg: `${str} is invalid input character.`
                });
            } else {
                this.setState({
                    GuestName: event.target.value.substring(0, len - 1),
                    error: true, errorMsg: `${str} is invalid input character.`
                });
            }
        }
        if (field === "roomNo") {
            this.setState({ roomNo: event.target.value });
        } else {
            this.setState({ GuestName: event.target.value });
        }
    }

    blurWithSubmit = (event) => {
        console.log("blurWithSubmit", event.relatedTarget);
        if (event && event.relatedTarget && event.relatedTarget.id === 'guestDevRegNext') {
            if (this.state.submitClick) {
                this.setState({ submitClick: false })
                this.handleSubmit(event)
            }
        }
        event.preventDefault();
        document.body.scrollTop = 0;
        window.scrollTo(0, 0);
    }

    submitKeyEvent = (event) => {
        if (event.keyCode === 13) {
            console.log("keycode", event.keyCode);
            //document.getElementById("guestDevRegNext").click();
            if (this.state.submitClick) {
                this.setState({ submitClick: false })
                this.handleSubmit(event);
            }
            event.preventDefault();
        }
    }

    submitAfterBlur = (event) => {
        event.preventDefault();
        if (this.state.submitClick) {
            this.setState({ submitClick: false })
            this.handleSubmit(event);
        }
    }


    render() {
        let reservationNo = localStorage.getItem("reservationNo");
        return (
            <Fragment>
                <section id="app-body" className="col"
                    style={this.props.errorPopUP ? {
                        zIndex: "9990", position: "absolute",
                        display: "none", top: 0, height: "100%",
                        background: "rgba(0, 0, 0, 0.9)"
                    } : {
                            zIndex: "9990", position: "absolute",
                            display: "block", top: 0, height: "100%",
                            background: "rgba(0, 0, 0, 0.9)"
                        }}>
                    <div id="ico-devReg" className="contentSection overUnder columns h-100 center-v">
                        <div id="guestDevReg" className="col" style={{
                            background: "rgba(255,255,255,0.95)", marginRight: 0,
                            padding: "1rem", maxWidth: "30rem",
                            margin: "0 auto", height: "auto"
                        }}>
                            <div id="connectorReg" className="form">
                                <form
                                    id="submitGuestLogin"
                                    style={{ color: "inherit" }}>
                                    {!this.state.showOnlyReservation ?
                                        <div className="form-item" style={{ color: "inherit" }}>
                                            <label for="client-name" style={{ color: "inherit" }}>Last Name:</label>
                                            <input
                                                id="InputForguestName2"
                                                ref={(input) => { this.nameInput = input; }}
                                                type="input"
                                                name="guestName"
                                                placeholder=""
                                                minlength="3"
                                                maxlength="50"
                                                onChange={(event) => { this.handleCHange(event, "guestName") }}
                                                value={this.state.deviceName}
                                                style={{ width: "100%", color: "inherit" }}
                                                onBlur={(event) => { setWebViewAfterKeyBoard(event) }}
                                                required />
                                        </div>
                                        : null}

                                    <div style={{ paddingLeft: "1rem" }}>
                                        {
                                            this.state.deviceError ?
                                                this.state.deviceErrorMsg : null
                                        }
                                    </div>
                                    {!this.state.showOnlyReservation ?
                                        <div className="form-item" style={{ color: "inherit" }}>
                                            <label for="client-comment" style={{ color: "inherit" }}>Room No:</label>
                                            <input
                                                id="InputForroomNo2"
                                                type="input"
                                                name="roomNo"
                                                value={this.state.roomNo}
                                                placeholder=""
                                                minlength="2"
                                                maxlength="15"
                                                onKeyDown={this.submitKeyEvent}
                                                style={{ width: "100%", color: "inherit" }}
                                                onChange={(event) => { this.handleCHange(event, "roomNo") }}
                                                onBlur={(event) => { this.blurWithSubmit(event) }}
                                                required />
                                        </div>
                                        : null}
                                    <div style={{ paddingLeft: "1rem", color: "red", fontWeight: "bold" }}>
                                        {
                                            this.state.error ?
                                                this.state.errorMsg : null
                                        }
                                    </div>
                                    {/* <div className="form-item" style={{ color: "inherit" }}>
                                        <label for="client-comment" style={{ color: "inherit" }}>Reservation No:</label>
                                        <input
                                            id="reservationNo"
                                            type="input"
                                            name="reserveNo"

                                            placeholder=""
                                            minlength="2"
                                            maxlength="15"
                                            //onKeyDown={this.submitKeyEvent}
                                            style={{ width: "100%", color: "inherit" }}
                                            onBlur={(event) => { this.blurWithSubmit(event) }}
                                            required />
                                    </div> */}
                                    <div className="form-controls">
                                        <button
                                            onClick={this.submitAfterBlur}
                                            type="submit" id="guestDevRegNext" className="primary">Connect</button>
                                        <button className="secondary" onClick={this.onNoClick}>Cancel</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    
                </section >
                {this.state.showRoomDoorPage && <HashRouter>
                    <Redirect exact to ="/doorKey/roomDoorKey"/>
                </HashRouter>}
            </Fragment>
        )
    }
}

const mapStateToProps = state => {
    return {
        menuColor: state.store.home.MenuColor,
        guestLoginPage: state.store.guestLoginPage,
        currentWidget: state.store.sideNavBar.currentWidget,
        guestDetail: state.store.home.guestDetails,
        doorLogin: state.store.doorKey.doorLogin,
        rescan: state.store.doorKey.rescan,
        QRScanPage: state.store.QRScannerPage,
        errorPopUP: state.store.doorKey.errorPopUP,
        currentHomePage: state.store2.currentHomePage,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
    }
}
export default connect(
    mapStateToProps,
    {
        setRegPage,
        setLoadingMass,
        validateGuestdetail,
        popupOpenClose,
        setDeviceLoginPage,
        currentWidget,
        validateReservationNo,
        setDoorKeyValidationPopUp,
        SetCallNativeMethods,

        setDoorKeyNotificaionPage,
        setQRScannerPage,
        setErrorPopDoorKey,
        setToRescan,
        setLocationId,
        setShowRoomDoor,
        sendAnalytics
    }
)(LoginPopUp);
